module.exports = __webpack_public_path__ + "static/img/operaingBanner.6e7539b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaingBanner.png
// module id = hqJk
// module chunks = 1